import React ,{Component} from "react";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";
import {Col, Container, Row, Image} from "react-bootstrap";


class Structure extends Component {
    render() {
        return (
            <div>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <header className="page-header section-padding pt-0">
                        <Container className="mt-80">
                            <Row >
                                <Col lg={8} className='mb-50'>
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>معرفی شرکت</span>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>ساختار سازمانی</span>
                                        </div>
                                        <h2 className="fz-25">هیات مدیره</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={10} className='m-auto'>
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/structure/directors.jpg"} alt=''/>
                                </Col>
                            </Row>
                            <br/><br/><br/>
                            <Row>
                                <Col lg={8} className='mb-50'>
                                    <div className="caption">
                                        <h2 className="fz-25">نمودار سازمانی</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={10} className='m-auto'>
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/structure/chart.jpg"} alt=''/>
                                </Col>
                            </Row>
                        </Container>
                    </header>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </div>
        );
    }
}

export default Structure;
